<template>
  <div class="header header2">
    <div class="wp-header">
      <a href="/" class="logo" title="迅雷"></a>
      <ul class="header-nav">
        <li v-for="(item, i) in tabs" :key="i">
          <a
            href="javascript:;"
            :class="{ cur: checkPath(item.path) }"
            @click="goRouter(item)"
          >
            {{ item.title }}
          </a>
        </li>
        <li>
          <UserInfo />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import UserInfo from '../logic-common/MinUserInfo'
export default {
  components: {
    UserInfo
  },
  data() {
    return {
      cur: 0
    }
  },
  computed: {
    curRoute() {
      return this.$store.state.route
    },
    curGameId() {
      return this.curRoute.params.game_id
    },
    tabs() {
      const gameId = this.curGameId
      return [
        {
          title: '游戏官网',
          path: `/game-offical/${gameId}/`,
          target: '_self'
        },
        {
          title: '游戏资讯',
          path: `/game-offical/${gameId}/notice/list?type=0`,
          target: '_self'
        },
        {
          title: '游戏资料',
          path: `/game-offical/${gameId}/notice/list?type=3`,
          target: '_self'
        },
        {
          title: '游戏充值',
          path: `/recharge?game_id=${gameId}`,
          target: '_blank'
        },
        { title: '客服中心', path: '/customer', target: '_blank' }
      ]
    }
  },
  methods: {
    checkPath(path) {
      if (path.includes('/notice/list')) {
        const type = this.$route.query.type
        return path.includes(`type=${type}`)
      } else {
        return this.curRoute.path === path
      }
    },
    goRouter({ path, target }) {
      if (target === '_blank') {
        window.open(path)
      } else {
        this.$router.push({
          path
        })
      }
    }
  }
}
</script>
